import "@hotwired/turbo-rails";

document.addEventListener("turbo:load", function() {
    // Login Errors - Triggers the display of flash area on login page
    // Select the elements with class 'flash__container' and their child divs
    var flashContainer = document.querySelectorAll('.flash__container > div');

    // Check if any of the selected elements have non-empty text content
    var hasNonEmptyText = Array.from(flashContainer).some(function(element) {
        return element.textContent.trim().length > 0;
    });

    // If any of the elements have non-empty text content, perform the slide down animation
    if (hasNonEmptyText) {
        var flashContainerParent = document.querySelector('.flash__container');
        flashContainerParent.style.display = 'block'
        flashContainerParent.style.height = 'auto'
    }
});